import React from 'react';
import OtherPagesHero from '../components/OtherPagesHero/OtherPagesHero';
import MainServices from '../components/MainServices/MainServices';

const ServicesPage = () => {
  return (
    <>
      <OtherPagesHero heading="Services" />
      <MainServices />
    </>
  );
};

export default ServicesPage;
